export const IS_VISIBLE_HANDBOOK_FEATURE = true;

export const VISICOM_DATA_API = '94427f5fd1a13b2936cd4fc9f59830a1';

// window is not defined on the server side
export const isClientSide = typeof window !== 'undefined';
